module.exports = __webpack_public_path__ + "71855287fe4d8ce156d120821e4159d0.svg";